export const INPUT_MINIMUM_LENGTH = 6;
export const USERNAME_INPUT_MINIMUM_LENGTH = 4;

export const FORGOT_PW_TOKEN_ERROR_CODES = {
	TOKEN_INVALID: 'be.api.fgpw.tokenInvalid',
	TOKEN_EXPIRED: 'be.api.fgpw.tokenExpired',
	TOKEN_USED: 'be.api.fgpw.tokenUsed',
};

export const isForgotPwTokenErrorCode = (errorCode) => {
	return errorCode === FORGOT_PW_TOKEN_ERROR_CODES.TOKEN_INVALID
		|| errorCode === FORGOT_PW_TOKEN_ERROR_CODES.TOKEN_EXPIRED
		|| errorCode === FORGOT_PW_TOKEN_ERROR_CODES.TOKEN_USED;
};

export const isEmpty = (input) => input.length === 0;
export const isTooShort = (input) => input.length < INPUT_MINIMUM_LENGTH && input.length > 0;